<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">{{ isEdicao ? 'Editar condição de pagamento' : 'Nova condição de pagamento' }}</h1>
                        <p class="welcome-message">
                            <button mat-icon-button (click)="voltar()">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            {{ isEdicao
                                ? 'Alterações valem para os próximos documentos; o histórico dos já emitidos é preservado.'
                                : 'Disponível apenas para formas de recebimento com parcelamento configurável pela empresa.' }}
                        </p>
                    </div>
                </div>
            </div>

            @if (isLoading) {
            <div class="col-12">
                <app-loading-box height="220"></app-loading-box>
            </div>
            } @else {
            <div class="col-12">
                <form [formGroup]="form">

                    <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

                    <!-- ═══════════════════ SEÇÃO 1 — Identificação ═══════════════════ -->
                    <div class="section-container" id="identificacao">
                        <div class="section-title">
                            <mat-icon>info</mat-icon>
                            <span>Identificação</span>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Nome da condição</mat-label>
                                    <input matInput formControlName="nome" placeholder="Ex.: 3x sem juros">
                                    @if (form.get('nome')?.invalid) {
                                    <mat-error>Informe o nome da condição.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="toggle-content">
                            <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivo" color="primary">
                                Condição ativa
                            </mat-slide-toggle>
                            <span class="info-text">
                                Condições inativas deixam de aparecer nos documentos, mas continuam preservadas no
                                histórico dos documentos que já as usaram.
                            </span>
                        </div>
                    </div>

                    <!-- ═══════════════════ SEÇÃO 2 — Estrutura de parcelas ═══════════════════ -->
                    <div class="section-container" id="parcelas">
                        <div class="section-title">
                            <mat-icon>event_repeat</mat-icon>
                            <span>Estrutura de parcelas</span>
                        </div>

                        <div class="modo-cards">
                            @for (modo of modosDisponiveis; track modo.id) {
                            <button type="button" class="modo-card" [class.selected]="modoAtual === modo.id"
                                (click)="selecionarModo(modo.id)">
                                <mat-icon>{{ modo.icon }}</mat-icon>
                                <span class="modo-card-texto">
                                    <span class="modo-card-label">{{ modo.label }}</span>
                                    <span class="modo-card-hint">{{ modo.hint }}</span>
                                </span>
                            </button>
                            }
                        </div>

                        <div class="row mt-4">
                            <div class="col-md-4 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Número de parcelas</mat-label>
                                    <input matInput [currencyMask]="integerMask" formControlName="numeroParcelas">
                                    @if (form.get('numeroParcelas')?.hasError('min')) {
                                    <mat-error>Deve ser no mínimo 1.</mat-error>
                                    }
                                </mat-form-field>
                            </div>

                            @if (modoUnico) {
                            <div class="col-md-4 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Intervalo entre parcelas (dias)</mat-label>
                                    <input matInput [currencyMask]="integerMask" formControlName="intervaloDias">
                                </mat-form-field>
                            </div>
                            }

                            <div class="col-md-4 col-12">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Taxa de juros cobrada do cliente (%)</mat-label>
                                    <input matInput formControlName="taxaJuros" placeholder="0,00"
                                        [currencyMask]="percentMask">
                                </mat-form-field>
                            </div>
                        </div>

                        @if (modoLista) {
                        <div class="dias-por-parcela" formArrayName="dias">
                            <div class="dias-por-parcela-titulo">Dias por parcela</div>
                            <div class="row">
                                @for (dia of diasArray.controls; track $index; let i = $index) {
                                <div class="col-md-3 col-6">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Parcela {{ i + 1 }} (dias)</mat-label>
                                        <input matInput [currencyMask]="integerMask" [formControlName]="i">
                                    </mat-form-field>
                                </div>
                                }
                            </div>
                            <div class="dias-por-parcela-nota">
                                <mat-icon>info</mat-icon>
                                A primeira parcela pode ter prazo diferente das seguintes — equivale às expressões
                                "30 60 90" e "15 +2x" do texto livre.
                            </div>
                        </div>
                        }

                        <div class="previa-container">
                            <div class="previa-titulo">
                                Prévia dos vencimentos · referência hoje · documento de {{ valorReferenciaPrevia | abnt:'preco':2 }}
                            </div>
                            <div class="previa-cards">
                                @for (p of previaVencimentos(); track p.rotulo) {
                                <div class="previa-card">
                                    <div class="previa-card-rotulo">{{ p.rotulo }}</div>
                                    <div class="previa-card-data">{{ p.data }}</div>
                                    <div class="previa-card-detalhe">{{ p.valor | abnt:'preco':2 }} · {{ p.diasLabel }}</div>
                                </div>
                                }
                            </div>
                            <div class="previa-nota">
                                @if (taxaJurosPrevia > 0) {
                                Taxa de {{ taxaJurosPrevia | abnt:'quantidade':2 }}% aplicada sobre o total: {{ valorReferenciaPrevia | abnt:'preco':2 }} passa a {{ totalComJurosPrevia | abnt:'preco':2 }}, distribuídos entre as parcelas com ajuste de arredondamento na última.
                                } @else {
                                Sem taxa de juros: o total do documento é distribuído entre as parcelas, com ajuste de arredondamento na última.
                                }
                            </div>
                        </div>
                    </div>

                    <!-- ═══════════════════ SEÇÃO 3 — Formas de recebimento aplicáveis ═══════════════════ -->
                    <div class="section-container" id="formas">
                        <div class="section-title">
                            <mat-icon>account_balance_wallet</mat-icon>
                            <span>Formas de recebimento aplicáveis</span>
                        </div>

                        <p class="formas-subtitulo">
                            Escolha em quais formas de recebimento esta condição poderá ser usada. Deixe sem marcação
                            para liberar a condição em qualquer forma de pagamento com parcelamento configurável pela
                            empresa — Boleto, Crediário e as formas de recebimento cadastradas por você.
                        </p>

                        <div class="formas-select">
                            <app-select-pesquisavel [control]="$any(form.get('idsFormaRecebimento'))"
                                [multiple]="true" [showBadges]="true" idField="id" nameField="descricao"
                                [offlineList]="formasRecebimentoLookup" label="Formas de recebimento"
                                hint="Sem marcação: a condição vale para qualquer forma com parcelamento configurável pela empresa.">
                            </app-select-pesquisavel>
                        </div>

                        <div class="formas-nota">
                            <b>Não encontrou alguma forma de pagamento?</b>
                            Formas à vista (Dinheiro, Depósito) e intermediadores de pagamento (Pix, Cartões) são
                            configurados em outra tela.
                        </div>
                    </div>

                </form>
            </div>
            }
        </div>
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
    (salvar)="salvar()">
</app-footer-action>
